export function resolveIndex(index: number, { length }: { length: number }): number {
  const newIndex = index % Math.max(length, 1)
  if (newIndex < 0) return length + newIndex
  else return newIndex
}
